import React from "react";
import "../../assets/css/seller-dashboard.css";
import "../../assets/css/seller-order-details.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import { detail_order_img } from "../../constants";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";

const Seller_order_detail = () => {
	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
						</div>
						<div className="col-lg-8">
							<Seller_tabs_list />

							<div className="order_details" style={{ marginTop: "30px" }}>
								<div className="order-no">
									<p>Order #12345 was placed on 5 feb 2022</p>
								</div>
								<div className="about-order">
									<div className="title">
										<h4>Order Detail</h4>
									</div>
									<div className="product detailed">
										<div className="property">
											<p>Product :</p>
										</div>
										<div className="value">
											<img src={detail_order_img} alt="" />
										</div>
									</div>
									<div className="product-name detailed">
										<div className="property">
											<p>Product Name :</p>
										</div>
										<div className="value">
											<p>Koizuma Massage Gun </p>
										</div>
									</div>
									<div className="subtotal detailed">
										<div className="property">
											<p>Sub Total :</p>
										</div>
										<div className="value">
											<p>$ 8.00</p>
										</div>
									</div>
									<div className="shipping detailed">
										<div className="property">
											<p>Shipping</p>
										</div>
										<div className="value">
											<p>$ 2</p>
										</div>
									</div>
									<div className="payment-method detailed">
										<div className="property">
											<p>Payment method</p>
										</div>
										<div className="value">
											<p>Bank transfer</p>
										</div>
									</div>

									<div className="net-total detailed">
										<div className="property">
											<p>Admin Commission</p>
										</div>
										<div className="value">
											<p>$ 10.00</p>
										</div>
									</div>
									<div className="net-total detailed">
										<div className="property">
											<p>Total</p>
										</div>
										<div className="value">
											<p>$ 10.00</p>
										</div>
									</div>
								</div>
								<div className="button-group">
									<a href="/seller-order" className="print_order btn">
										Back
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_order_detail;
